import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import { useLocation } from 'react-router';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';
import React from 'react';
import { TabProps } from '@mui/material/Tab';

const TabsLayoutRoot = styled('div', { name: 'TabsLayoutRoot' })(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

const TabsLayoutTabsWrapper = styled('div', { name: 'TabsLayoutTabsWrapper' })(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  flex: 0,
  zIndex: 1,
}));

export const TabsLayoutTabContent = styled(Paper, { name: 'TabsLayoutTabContent' })<{
  firstTabHighlited: boolean;
}>(({ firstTabHighlited, theme }) => ({
  borderRadius: DEFAULT_BORDER_RADIUS,
  borderTopLeftRadius: firstTabHighlited ? 0 : DEFAULT_BORDER_RADIUS,
  border: `1px solid ${theme.palette.border}`,
  overflow: 'hidden',
  flex: 1,
  marginTop: theme.spacing(-1),
  zIndex: 0,
  '& > *': {
    height: '100%',
  },
}));

export const TABS_ROOT_ID = 'tabsRoot';

export type TabsContainerProps = {
  content: React.ReactNode;
  children: React.ReactNode;
};

export const TabsLayout = ({ children, content }: TabsContainerProps) => {
  const location = useLocation();

  const firstTab = React.Children.toArray(children)[0];
  let highlited = false;
  if (React.isValidElement<TabProps>(firstTab)) {
    highlited = firstTab.props.value === location.pathname;
  }

  return (
    <TabsLayoutRoot>
      <TabsLayoutTabsWrapper id={TABS_ROOT_ID}>
        <Tabs value={location.pathname}>{children}</Tabs>
      </TabsLayoutTabsWrapper>
      <TabsLayoutTabContent firstTabHighlited={highlited} elevation={0}>
        {content}
      </TabsLayoutTabContent>
    </TabsLayoutRoot>
  );
};
